var _rect, _path, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.999,
    height: 30,
    rx: 14.9995,
    fill: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9995 0C6.71551 0 0 6.716 0 15C0 15.2009 0.00395012 15.4009 0.0117769 15.5999C0.326665 7.59397 6.91642 1.19979 14.9995 1.19979C23.0826 1.19979 29.6724 7.59397 29.9872 15.5999C29.9951 15.4009 29.999 15.2009 29.999 15C29.999 6.716 23.2835 0 14.9995 0Z",
    fill: "white",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 29.9998C23.2842 29.9998 29.9998 23.2838 29.9998 14.9998C29.9998 14.7989 29.9958 14.5989 29.988 14.3999C29.6731 22.4058 23.0833 28.8 15.0002 28.8C6.91715 28.8 0.327384 22.4058 0.0125098 14.3998C0.00468198 14.5988 0.000731843 14.7988 0.000731826 14.9998C0.000731102 23.2838 6.71624 29.9998 15.0002 29.9998Z",
    fill: "#030303",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 4,
    height: 8,
    fill: "#FFC800"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 4,
    height: 12,
    fill: "#FFC800"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 4,
    height: 16,
    fill: "#FFC800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.a3fa740018d533d7294743948988b01d.svg";
export { ForwardRef as ReactComponent };